// screeners/actionTypes.js

const REQUEST_SCREENER_ACCESS = '@@profile/REQUEST_SCREENER_ACCESS';
const SCREENER_ACCESS_RESPONSE = '@@profile/SCREENER_ACCESS_RESPONSE';

export default { REQUEST_SCREENER_ACCESS, SCREENER_ACCESS_RESPONSE };
